import api from '@/apis/bu/bUOpeningCommitmentAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('bUOpeningCommitment', api);

const state = {
  ...crud.state,
  _config: {
    table: 'bu_opening_commitment',
    field: {
      key: 'ref_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
